import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/ebook.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/lamp-over-desk.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/src/components/animation/AnimateBoxSlideDown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dawid/Work/aw-sport/src/components/Nav.tsx");
